import Vue from 'vue'
import Router from 'vue-router'
import FormularioPage from '@/View/FormularioPage'
import SsoPage from '@/View/SsoPage'
import ApuracaoPage from '@/View/ApuracaoPage'
import GerenciarFormularioPage from '@/View/GerenciarFormularioPage'
import LoginPage from '@/View/LoginPage'
import CadastroPessoaPage from '@/View/CadastroPessoaPage'
import RedirecionarPage from '@/View/RedirecionarPage'
import FormularioDisponivelResponder from '@/View/FormulariosDisponivelResponder'
import FinalizacaoFormularioAtendimentoAssistido from '@/View/FinalizacaoFormularioAtendimentoAssistido'
import AreaLogadaMainPage from '@/View/AreaLogada/MainPage'
import HomePage from '@/View/HomePage'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name:'HomePage',
      component:HomePage   
    },
  
    {
      path:'/:apelidoCliente/area-logada',
      component: AreaLogadaMainPage,
      children:[
        {
          path:'redirecionar',
          name:'RedirecionarPage',
          component:RedirecionarPage
        },
        {
          path:'listagem-formulario',
          name:'ListagemFormulario',
          component:FormularioDisponivelResponder
        },
        {
          path:'cadastro',
          name:'CadastroPessoaPage',
          component:CadastroPessoaPage
        }
      ]
    },
    
    {
      path: '/gerenciar-formulario',
      name: 'GerenciarFormularios',
      component: GerenciarFormularioPage
    },

    {
      path: '/responder/formulario/:formularioId/cliente/:codigoCliente',
      name: 'responderFormulario',
      component: FormularioPage
    },
    {
      path: '/responder/formulario/:formularioId/cliente/:codigoCliente/:data',
      name: 'responderFormularioAssistido',
      component: SsoPage
      
    },
    {
      path:'/:apelidoCliente/login/',
      name:'LoginPage',
      component:LoginPage
    },
    {
      path: '/apuracao/parcial/:formId',
      name: 'ApuracaoParcialPage',
      component: ApuracaoPage
    },
    {
      path:'/:apelidoCliente',
      component: AreaLogadaMainPage,
      children:[
        {
          path:'/:apelidoCliente/primeiro-acesso',
          name:'PrimeiroAcesso',
          component:CadastroPessoaPage
        }
      ]
    },
    {
      path:'/finalizar/atendimento-assistido',
      name:'FinalizacaoAtendimentoAssistido',
      component:FinalizacaoFormularioAtendimentoAssistido
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js